import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { getTimeFormat } from '@utils/dateHelper';
import { deleteStaffTimeSlot } from '@services/reservationService';

interface TimeSlot {
  _id: string;
  start: string;
  end: string;
  title: string;
  remark: string;
  isOpen: boolean;
  [key: string]: unknown;
}

interface Stylist {
  _id: string;
  availability: {
    startHour?: string;
    endHour?: string;
    isDefaultClose?: boolean;
    timeSlots: TimeSlot[];
    leaveDates: string[];
    dayoff: number[];
  };
}

export interface SelectedSlotDialogProps {
  isOpen: boolean;
  slot: TimeSlot;
  onClose: () => void;
  stylist: Stylist;
  setStylistData: (data: Stylist) => void;
}

const SelectedSlotDialog = ({ isOpen, slot, onClose, stylist, setStylistData }: SelectedSlotDialogProps) => {
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{isOpen ? 'Open' : 'Blocked'} Details</DialogTitle>
      <DialogContent>
        <Typography><strong>{isOpen ? 'Open' : 'Blocked'}</strong> {getTimeFormat(slot.start)} - {getTimeFormat(slot.end)}</Typography>
        <Typography><strong>Title:</strong> {slot.title}</Typography>
        <Typography><strong>Remark:</strong> {slot.remark}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          deleteStaffTimeSlot({staffId: stylist._id, timeSlotId: slot._id}).then((response) => {
            const updatedStylist: Stylist = {
              ...stylist,
              availability: {
                ...stylist.availability,
                timeSlots: response.data as TimeSlot[]
              }
            };
            setStylistData(updatedStylist);
            onClose();
          }).catch((error: unknown) => {
            console.error('Error deleting time slot:', error);
          });
        }} color="primary">Delete</Button>
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectedSlotDialog;
